import patients from "./patients";
import auth from "./auth";
import location from "./location";
import appointments from "./appointments";
import images from "./images";
import reports from "./reports";
import doctors from "./doctors";
import treatments from "./treatments";

export default {
  doctors,
  patients,
  auth,
  location,
  appointments,
  images,
  reports,
  treatments,
};
